import HeroSection from "@/components/hero-section";
import HowItWorks from "@/components/how-it-works";
import Stats from "@/components/stats";
import LiveFeed from "@/components/live-feed";

const Home = () => {
  return (
    <div>
      <HeroSection />
      <Stats />
      <HowItWorks />
      <LiveFeed />
    </div>
  );
};

export default Home;
